import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as Sentry from "@sentry/react";
class ErrorBoundary extends React.Component {
    componentDidCatch(error, errorInfo) {
      Sentry.withScope((scope) => {
        scope.setExtras(errorInfo);
        const sentryEventId = Sentry.captureException(error);
        console.info("sentry event id", sentryEventId)
        this.setState({ sentryEventId });
      });
      }
      
    render() {
      return (
          <App/>
      )
    }
  }

ReactDOM.render(<ErrorBoundary/>, document.getElementById('root'))
